export default __webpack_public_path__ + "static/media/headshot-dxb.4a25d55e.webp";